import { C } from "../../shared/theme";
import { FEELINGS } from "./learnContent";
import { pageTitle, intro, card, resetButton } from "./learnStyles";
import { feelingView } from "./useLearnNav";

// "I'm stuck right now": pick the sentence that sounds most like you; each opens its own page.
export function StuckPage({ onOpen }) {
  return (
    <div style={{ padding: "4px 20px 28px", display: "flex", flexDirection: "column", gap: 12 }}>
      <h1 tabIndex={-1} style={{ ...pageTitle, color: C.text, outline: "none" }}>I'm stuck right now</h1>
      <p style={intro()}>Which of these sounds most like you at the moment?</p>
      <ul style={{ ...card(), margin: 0, padding: 0, listStyle: "none" }}>
        {FEELINGS.map(f => (
          <li key={f.id}>
            <button onClick={() => onOpen(feelingView(f.id))}
              style={{ ...resetButton, width: "100%", minHeight: 52, display: "flex", gap: 12, alignItems: "center", padding: "12px 14px", borderBottom: `1px solid ${C.border}`, marginBottom: -1, color: C.text }}>
              <span style={{ flex: 1, fontSize: 16, fontWeight: 600, lineHeight: 1.35 }}>{f.label}</span>
              <span aria-hidden="true" style={{ color: C.textDim, fontSize: 19, lineHeight: 1.2 }}>›</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
